import { useEffect, useRef, type InputHTMLAttributes } from 'react';
import { CheckIcon } from '../icons/Icons';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  /** Renders the mixed state used by the "select all" box. */
  indeterminate?: boolean;
}

export function Checkbox({ label, indeterminate = false, ...props }: CheckboxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <label className="checkbox">
      <input ref={inputRef} type="checkbox" aria-label={label} {...props} />
      <span className="checkbox__box">
        <CheckIcon size={11} className="checkbox__tick" />
      </span>
    </label>
  );
}
